import React from 'react'
import { Mentor } from '../../cards/Mentor'
import MentorsData from '../../../data/Mentors.json'

export const Mentors = () => {
    return (
        <div className='px-[5vw] py-20 w-full'>
            {/* // This is the title */}
            <h2 className='text-3xl text-blue-500 font-semibold'>Mentors</h2>

            {/* // This is the List of Supporters*/}
            <div className='mt-20 w-full grid lg:grid-cols-2 grid-cols-1 gap-5'>
                {
                    MentorsData.map((mentor, index) => (
                        <Mentor key={index} name={mentor.name} des={mentor.description} image={mentor.image} />
                    ))
                }
            </div>

        </div>
    )
}
